import React from 'react';
import { X } from 'lucide-react';
import { SIGN_UP_SHEET, GHOST_URL, FORM_URL } from '../../lib/appConstants';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface SignUpModalProps {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  isMobile: boolean;
  formUrl?: string;
  eventsUrl?: string;
  blogUrl?: string;
}

const SignUpModal: React.FC<SignUpModalProps> = ({
  isOpen,
  onClose,
  headerText,
  isMobile,
  formUrl = SIGN_UP_SHEET,
  eventsUrl = FORM_URL,
  blogUrl = GHOST_URL,
}) => {
  const handleConfirm = () => {
    window.open(formUrl, '_blank', 'noopener,noreferrer');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[10000] animate-overlayShow"
        onClick={onClose}
      />

      {/* Dialog */}
      <div
        className="fixed z-[10001] bg-white rounded-2xl shadow-2xl animate-contentShow"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(100% - 48px)',
          maxWidth: '380px',
          padding: '24px',
        }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className={`absolute ${isMobile ? 'top-1 right-1' : 'top-3 right-3'} p-1 rounded-full hover:bg-gray-100 transition-colors`}
          style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
        >
          <X size={20} color="#666" />
        </button>

        {/* Content */}
        <div className="text-center pt-2">
          <h3 className="text-lg font-semibold mb-2 text-gray-900">{headerText}</h3>
          <div className="flex item-center align-middle mb-2 w-full">
            <div className="flex items-center justify-center w-full">
              <DotLottieReact
                src="https://lottie.host/57d701c8-2d3e-4138-ae9f-387104dbef26/ipPqZAQ7AE.lottie"
                loop
                autoplay
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </div>
          <p className="text-gray-600 mb-6 text-sm leading-relaxed">
            read our{' '}
            <a
              href={blogUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'rgba(230, 0, 126, 1)' }}
              className="underline hover:no-underline transition-all"
            >
              blog
            </a>{' '}
            or send us an{' '}
            <a
              href={eventsUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'rgba(230, 0, 126, 1)' }}
              className="underline hover:no-underline transition-all"
            >
              event
            </a>
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={handleConfirm}
              className="flex-1 py-3 px-4 rounded-xl font-medium transition-all"
              style={{
                backgroundColor: 'rgba(230, 0, 126, 1)',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(230, 0, 126, 0.3)',
              }}
            >
              hop on our waitlist!
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpModal;
